import {Dispatch, SetStateAction, useCallback, useState} from 'react';
import {PaymentMethodValues} from '../../../../shopping-basket/cash-payment/utils/helpers';
import {PayStep} from '../LendTechPaySheetTypes';

interface Options {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

// When the user's credit does not cover the whole order, the remainder is paid
// in cash, so the payment type changes to its "mixed" counterpart.

const resolveFinalPaymentType = (
  paymentType: PaymentMethodValues | undefined,
  isCreditsEnough: boolean | null,
) => {
  if (isCreditsEnough !== false) return paymentType;

  switch (paymentType) {
    case PaymentMethodValues.CREDIT_PAYMENT:
      return PaymentMethodValues.CASH_CREDIT_PAYMENT;

    case PaymentMethodValues.CASHBACK_PAYMENT:
      return PaymentMethodValues.CASHBACK_CASH_PAYMENT;

    default:
      return paymentType;
  }
};

// selection process
// method -> creditType -> creditDetails -> otp
export const useLendTechPayFlow = ({isOpen, setIsOpen}: Options) => {
  const [step, goTo] = useState<PayStep>(PayStep.Method);
  const [paymentType, setPaymentType] = useState<
    PaymentMethodValues | undefined
  >(undefined);
  const [isCreditsEnough, setIsCreditsEnough] = useState<boolean | null>(null);
  const [isInvalidCodeOpen, setIsInvalidCodeOpen] = useState(false);

  // Restart the process every time the parent re-opens it.
  // State adjusted during render, so there is no frame showing a stale step.
  const [wasOpen, setWasOpen] = useState(isOpen);

  if (isOpen !== wasOpen) {
    setWasOpen(isOpen);
    if (isOpen) {
      goTo(PayStep.Method);
      setPaymentType(undefined);
      setIsCreditsEnough(null);
    }
  }

  const close = useCallback(() => setIsOpen(false), [setIsOpen]);

  const showInvalidCode = useCallback(() => {
    setIsOpen(false);
    setIsInvalidCodeOpen(true);
  }, [setIsOpen]);

  return {
    step,
    goTo,
    paymentType,
    setPaymentType,
    finalPaymentType: resolveFinalPaymentType(paymentType, isCreditsEnough),
    setIsCreditsEnough,
    isInvalidCodeOpen,
    setIsInvalidCodeOpen,
    close,
    showInvalidCode,
  };
};
